import {StyleSheet, ViewStyle} from 'react-native';

import {Box} from '@buncha/components/core/view';
import React from 'react';
import {useColorThemeType} from '@buncha/appStyles/hooks/theme';

interface Props {
  containerStyle?: ViewStyle;
}
const SemiCircularDivider = (props: Props) => {
  const theme = useColorThemeType('main');
  return (
    <Box style={[styles.container, props?.containerStyle]}>
      <Box
        style={[
          styles.circle,
          styles.rightSemiCircle,
          {backgroundColor: theme?.background.gray[200]},
        ]}
      />
      <Box style={styles.dottedLine} />
      <Box
        style={[
          styles.circle,
          styles.leftSemiCircle,
          {backgroundColor: theme?.background.gray[200]},
        ]}
      />
    </Box>
  );
};

export default React.memo(SemiCircularDivider);

const styles = StyleSheet.create({
  container: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center',
    marginTop: 20,
    marginBottom: 10,
    marginLeft: -16,
    marginRight: -16,
  },
  circle: {
    width: 12,
    height: 22,
    borderRadius: 50,
    zIndex: 1,
  },
  leftSemiCircle: {
    transform: [{translateX: -6}],
    borderTopRightRadius: 0,
    borderBottomRightRadius: 0,
  },
  rightSemiCircle: {
    transform: [{translateX: 6}],
    borderTopLeftRadius: 0,
    borderBottomLeftRadius: 0,
  },
  dottedLine: {
    flex: 1,
    height: 1,
    borderWidth: 1,
    borderColor: '#ddd',
    borderStyle: 'dotted',
    marginHorizontal: -6,
  },
});
